import { connect } from 'react-redux';
import { makeStyles, tokens } from '@fluentui/react-components';
import { AppState } from '../../../redux/reducers';
import { Sede } from '../../../models/Entities/Turnero';
import { ErrorType } from '../../../models/HttpError';
import * as SedesStore from '../../../redux/middleware/Turnero/Turnero.Sedes.Middleware';

export interface OwnProps {
  isOpen: boolean;
  onClose: () => void;
}

interface StateProps {
  isSaving: boolean;
  isSaved: boolean | undefined;
  failOnSaving: boolean;
  error: ErrorType | undefined;
}

interface DispatchProps {
  CreateSede: typeof SedesStore.actionCreators.CreateSede;
}

export type Props = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = (state: AppState, _ownProps: OwnProps): StateProps => ({
  isSaving: state.Turnero?.Sedes?.isAddingNewOne || false,
  isSaved: state.Turnero?.Sedes?.successAddingNewOne,
  failOnSaving: state.Turnero?.Sedes?.failOnAddingNewOne || false,
  error: state.Turnero?.Sedes?.error
});

export const mapDispatchToProps = {
  CreateSede: SedesStore.actionCreators.CreateSede
};

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: tokens.spacingHorizontalS,
  },
});

export const connector = connect(mapStateToProps, mapDispatchToProps);
